require('./lbFareRulesModal.scss');

const lbFareRulesModal = angular.module('app.lbFareRulesModal', []);

lbFareRulesModal.component('lbFareRulesModal', {
  controllerAs: 'vm',
  controller: ['lbModalService','$scope', controller],
  template: require('./lbFareRulesModal.html'),
});

function controller(lbModalService, $scope) {
  let vm = this;

  const params = lbModalService.params();
  const urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

  vm.carrierName = params.trip.CarrierName;
  vm.rulesType = params.fareRules.Type;
  vm.fareRulesText = params.fareRules.Data;

  function formatString(inputString) {
    return inputString.replace(/\./g, ".<br><br>");
}

  $scope.setActiveTab = function(selectedTab) {
    angular.forEach($scope.tabs, function(tab) {
      tab.active = (tab === selectedTab);
    });
  };

  if(params.fare){
    vm.fareInfo =  {
      FareBasis: params.fare.Code.filter(onlyUnique),
      ResBookDesignCode: params.fare.ResBookDesignCode.filter(onlyUnique),
      Brands: params.fare.Segments.map(seg=> 'BrandId: ' + seg.BrandId + ', BrandName: ' + seg.BrandName).filter(onlyUnique)
    };
    
  }

  function parseStringToObjects(inputString) {
  
    const createObject = (title, content, active) => ({
      title,
      content: content.join('\n').trim(),
      active
    });
    
    const sections = inputString.split(/\d{2}: /).slice(1);
    const result = sections.map((section, index) => {
      const [title, ...contentArray] = section.trim().split('\n');
      let content = contentArray.join('\n').trim();
      content = formatString(content);
      return { title: title.trim(), content, active: false };
    });
  
    const fareDetailsContent = [
      '<b>FARE BASIS</b> <BR><BR>',
      vm.fareInfo.FareBasis,
      '<BR><BR> <b>BRAND NAME</b> <BR><BR>',
      vm.fareInfo.Brands,
      '<BR><BR><b> RESERVATION CLASS OF SERVICE</b> <BR><BR>',
      vm.fareInfo.ResBookDesignCode,
    ];
     
    result.unshift(createObject("FARE DETAILS", fareDetailsContent, true));
       const penaltiesIndex = result.findIndex(tab => tab.title === 'PENALTIES');
       if (penaltiesIndex > 0) {
         const penaltiesTab = result[penaltiesIndex];
         result.splice(penaltiesIndex, 1);
         result.splice(1, 0, penaltiesTab);
       }
        const surchargesIndex = result.findIndex(tab => tab.title === 'SURCHARGES');
        if (surchargesIndex > 1) {
          const surchargesTab = result[surchargesIndex];
          result.splice(surchargesIndex, 2);
          result.splice(2, 0, surchargesTab);
        }
     
  
    return result;
  }

$scope.tabs = parseStringToObjects(vm.fareRulesText);



  if (vm.rulesType === 'ExternalUrl') {
    vm.fareRulesText = vm.fareRulesText.replace(urlReg, replaceLink);
  }

  function replaceLink(str) {
    return '<a href="' + str + '" target="_blank" rel="noreferrer noopener">' + 'Click here to view fare rules' + '</a>';
  }

  vm.close = lbModalService.resolve;
  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }
}

export default lbFareRulesModal;



// WEBPACK FOOTER //
// ./src/components/lbFareRulesModal/lbFareRulesModal.js